import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className}>
      <path
        d='M16 19V17.3333C16 16.4493 15.6576 15.6014 15.0481 14.9763C14.4386 14.3512 13.612 14 12.75 14H6.25C5.38805 14 4.5614 14.3512 3.9519 14.9763C3.34241 15.6014 3 16.4493 3 17.3333V19'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 11C11.6569 11 13 9.65685 13 8C13 6.34315 11.6569 5 10 5C8.34315 5 7 6.34315 7 8C7 9.65685 8.34315 11 10 11Z'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21 19V17.2964C20.9993 16.5415 20.7044 15.8082 20.1614 15.2115C19.6184 14.6149 18.8581 14.1887 18 14'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15 5C15.5721 5.17056 16.0792 5.55796 16.4413 6.10114C16.8034 6.64432 17 7.31238 17 8C17 8.68762 16.8034 9.35567 16.4413 9.89886C16.0792 10.442 15.5721 10.8294 15 11'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
});

export default React.memo(Icon);
